import React from "react";
import { Button, colors, SearchIcon } from "@commonsku/styles";
import AsyncDivisionSelect from "../../AsyncDivisionSelect";
import type { CatalogItemsFilters } from "./CatalogPage";
import {
  FilterActions,
  FilterField,
  FilterLabel,
  FiltersRow,
  SearchInputEndIcon,
  SearchInputShell,
  SearchTermInput,
} from "./catalogShared";

interface CatalogSearchSupplierFiltersProps {
  filters: CatalogItemsFilters;
  onFiltersChange: (patch: Partial<CatalogItemsFilters>) => void;
  onApplyFilters: () => void;
  onSearchKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
}

export const CatalogSearchSupplierFilters = ({
  filters,
  onFiltersChange,
  onApplyFilters,
  onSearchKeyDown,
  children,
}: CatalogSearchSupplierFiltersProps) => (
  <FiltersRow style={{ alignItems: 'flex-start' }}>
    <FilterField>
      <FilterLabel>Search by Product</FilterLabel>
      <SearchInputShell>
        <SearchTermInput
          type="text"
          placeholder="Name, description or external SKU"
          onChange={(e) => onFiltersChange({ search: e.target.value })}
          value={filters.search}
          onKeyDown={onSearchKeyDown}
          style={{ height: '49px' }}
        />
        <SearchInputEndIcon aria-hidden>
          <SearchIcon color={colors.primary1[65]} />
        </SearchInputEndIcon>
      </SearchInputShell>
    </FilterField>
    <FilterField>
      <FilterLabel>Supplier</FilterLabel>
      <AsyncDivisionSelect
        placeholder="All suppliers"
        value={filters.divisionId ?? ""}
        isClearable={!!filters.divisionId}
        onChange={(option: any) => {
          onFiltersChange({ divisionId: option?.value ?? null });
        }}
      />
    </FilterField>
    {children}
    <FilterActions>
      <Button
        type="button"
        variant="secondary"
        size="medium"
        onClick={onApplyFilters}
        style={{ marginTop: '30px', height: '49px' }}
      >
        Filter
      </Button>
    </FilterActions>
  </FiltersRow>
);
